<template>
  <Products :products="allProducts" />
</template>

<script>
import Products from '@/components/shop/Products.vue'
import { mapActions } from 'vuex'

export default {
  name: 'Home',
  components: {
    Products
  },
  data () {
    return {
      allProducts: null
    }
  },
  mounted () {
    this.loadProducts()
  },
  methods: {
    ...mapActions(['getProducts']),
    async loadProducts () {
      this.allProducts = await this.getProducts()
    }
  }

}
</script>

<style scoped lang="scss">
  .info{
    position: absolute;
    bottom: 50px;
    right: 20px;
    width: 30%;
    text-align: center;
}
</style>
